import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation, Route, Routes } from "react-router-dom";
import SidebarAdmin from "./Utils/SidebarAdmin";
import "./Dashboard.css";
import HelpIcon from "../images/help_icon.png";
import HelpQueryPopup from "./QueryManager/HelpQuery/HelpQueryPopup";
import MyQueriesPopup from "./QueryManager/MyQuery/MyQueriesPopup";
import QueryChatPopup, { help_desk_query } from "./QueryManager/QueryChat/QueryChatPopup";
import AllQueriesPopup from "./QueryManager/AllQueries/AllQueriesPopup";
import { LoginContext } from "../context/LoginContext";
import LogoutButton from "./LogoutButton";
import { apiFetch } from "../apis/apiFetch";
import apiConfig from "../config/apiConfig";
import "./DashboardAnalytics.css";
import { Application } from "./Resource/ViewRounds";

interface AnalyticsCounts {
  // Mtech
  total: number;
  submitted_paid: number;
  pending: number;
  cse_total: number;
  cse_submitted_paid: number;
  cse_pending: number;
  ece_total: number;
  ece_submitted_paid: number;
  ece_pending: number;
  ai_ds_total: number;
  ai_ds_submitted_paid: number;
  ai_ds_pending: number;

  offered: number;
  accepted: number;
  cse_off: number;
  ece_off: number;
  aids_off: number;

  declined: number;
  withdrwan: number;
  cancelled: number;

  // 🔵 MTECH R1/R2
  mtech_cse_accepted_r1: number;
  mtech_cse_declined_r1: number;
  mtech_cse_withdrawn_r1: number;
  mtech_cse_cancelled_r1: number;

  mtech_cse_accepted_r2: number;
  mtech_cse_declined_r2: number;
  mtech_cse_withdrawn_r2: number;
  mtech_cse_cancelled_r2: number;

  mtech_cse_accepted_r3: number;
  mtech_cse_declined_r3: number;
  mtech_cse_withdrawn_r3: number;
  mtech_cse_cancelled_r3: number;

  mtech_ece_accepted_r1: number;
  mtech_ece_declined_r1: number;
  mtech_ece_withdrawn_r1: number;
  mtech_ece_cancelled_r1: number;

  mtech_ece_accepted_r2: number;
  mtech_ece_declined_r2: number;
  mtech_ece_withdrawn_r2: number;
  mtech_ece_cancelled_r2: number;

  mtech_ece_accepted_r3: number;
  mtech_ece_declined_r3: number;
  mtech_ece_withdrawn_r3: number;
  mtech_ece_cancelled_r3: number;

  mtech_aids_accepted_r1: number;
  mtech_aids_declined_r1: number;
  mtech_aids_withdrawn_r1: number;
  mtech_aids_cancelled_r1: number;

  mtech_aids_accepted_r2: number;
  mtech_aids_declined_r2: number;
  mtech_aids_withdrawn_r2: number;
  mtech_aids_cancelled_r2: number;

  mtech_aids_accepted_r3: number;
  mtech_aids_declined_r3: number;
  mtech_aids_withdrawn_r3: number;
  mtech_aids_cancelled_r3: number;

  // 🔵 MTECH breakdown extras
  ece_AO: number;
  aids_AO: number;
  cse_AO: number;

  cse_DO: number;
  ece_DO: number;
  aids_DO: number;

  cse_WO: number;
  ece_WO: number;
  aids_WO: number;

  cse_CO: number;
  ece_CO: number;
  aids_CO: number;

  // Btech
  btech_total: number;
  btech_submitted_paid: number;
  btech_pending: number;

  btech_cse_total: number;
  btech_cse_submitted_paid: number;
  btech_cse_pending: number;

  btech_ece_total: number;
  btech_ece_submitted_paid: number;
  btech_ece_pending: number;

  btech_ai_ds_total: number;
  btech_ai_ds_submitted_paid: number;
  btech_ai_ds_pending: number;

  imtech_cse_total: number;
  imtech_cse_submitted_paid: number;
  imtech_cse_pending: number;

  imtech_ece_total: number;
  imtech_ece_submitted_paid: number;
  imtech_ece_pending: number;

  // BTECH OVERALL
  btech_offered: number;
  btech_accepted: number;
  btech_declined: number;
  btech_withdrawn: number;
  btech_cancelled: number;

  // BTECH CSE
  btech_cse_offered: number;

  btech_cse_accepted_r1: number;
  btech_cse_declined_r1: number;
  btech_cse_withdrawn_r1: number;
  btech_cse_cancelled_r1: number;

  btech_cse_accepted_r2: number;
  btech_cse_declined_r2: number;
  btech_cse_withdrawn_r2: number;
  btech_cse_cancelled_r2: number;

  btech_cse_accepted_r3: number;
  btech_cse_declined_r3: number;
  btech_cse_withdrawn_r3: number;
  btech_cse_cancelled_r3: number;

  // BTECH ECE
  btech_ece_offered: number;

  btech_ece_accepted_r1: number;
  btech_ece_declined_r1: number;
  btech_ece_withdrawn_r1: number;
  btech_ece_cancelled_r1: number;

  btech_ece_accepted_r2: number;
  btech_ece_declined_r2: number;
  btech_ece_withdrawn_r2: number;
  btech_ece_cancelled_r2: number;

  btech_ece_accepted_r3: number;
  btech_ece_declined_r3: number;
  btech_ece_withdrawn_r3: number;
  btech_ece_cancelled_r3: number;

  // BTECH AI/DS
  btech_aids_offered: number;

  btech_aids_accepted_r1: number;
  btech_aids_declined_r1: number;
  btech_aids_withdrawn_r1: number;
  btech_aids_cancelled_r1: number;

  btech_aids_accepted_r2: number;
  btech_aids_declined_r2: number;
  btech_aids_withdrawn_r2: number;
  btech_aids_cancelled_r2: number;

  btech_aids_accepted_r3: number;
  btech_aids_declined_r3: number;
  btech_aids_withdrawn_r3: number;
  btech_aids_cancelled_r3: number;

  // IMTECH CSE
  imtech_cse_offered: number;

  imtech_cse_accepted_r1: number;
  imtech_cse_declined_r1: number;
  imtech_cse_withdrawn_r1: number;
  imtech_cse_cancelled_r1: number;

  imtech_cse_accepted_r2: number;
  imtech_cse_declined_r2: number;
  imtech_cse_withdrawn_r2: number;
  imtech_cse_cancelled_r2: number;

  imtech_cse_accepted_r3: number;
  imtech_cse_declined_r3: number;
  imtech_cse_withdrawn_r3: number;
  imtech_cse_cancelled_r3: number;

  // IMTECH ECE
  imtech_ece_offered: number;

  imtech_ece_accepted_r1: number;
  imtech_ece_declined_r1: number;
  imtech_ece_withdrawn_r1: number;
  imtech_ece_cancelled_r1: number;

  imtech_ece_accepted_r2: number;
  imtech_ece_declined_r2: number;
  imtech_ece_withdrawn_r2: number;
  imtech_ece_cancelled_r2: number;

  imtech_ece_accepted_r3: number;
  imtech_ece_declined_r3: number;
  imtech_ece_withdrawn_r3: number;
  imtech_ece_cancelled_r3: number;

  // M.Tech offered
  mtech_cse_offered_r1: number;
  mtech_cse_offered_r2: number;
  mtech_cse_offered_r3: number;

  mtech_ece_offered_r1: number;
  mtech_ece_offered_r2: number;
  mtech_ece_offered_r3: number;

  mtech_aids_offered_r1: number;
  mtech_aids_offered_r2: number;
  mtech_aids_offered_r3: number;

  // B.Tech offered
  btech_cse_offered_r1: number;
  btech_cse_offered_r2: number;
  btech_cse_offered_r3: number;

  btech_ece_offered_r1: number;
  btech_ece_offered_r2: number;
  btech_ece_offered_r3: number;

  btech_aids_offered_r1: number;
  btech_aids_offered_r2: number;
  btech_aids_offered_r3: number;

  imtech_cse_offered_r1: number;
  imtech_cse_offered_r2: number;
  imtech_cse_offered_r3: number;

  imtech_ece_offered_r1: number;
  imtech_ece_offered_r2: number;
  imtech_ece_offered_r3: number;

  mtech_cse_with: number;
  mtech_ece_with: number;
  mtech_aids_with: number;
  btech_cse_with: number;
  btech_ece_with: number;
  btech_aids_with: number;
  imtech_cse_with: number;
  imtech_ece_with: number;

  btech_registered_online_r1: number;
  mtech_registered_online_r1: number;

  btech_cse_online_r1_accepted: number;
  btech_cse_online_r1_rejected: number;
  btech_cse_online_r1_withdrawn: number;
  btech_cse_online_r1_offer_cancelled: number;

  btech_ece_online_r1_accepted: number;
  btech_ece_online_r1_rejected: number;
  btech_ece_online_r1_withdrawn: number;
  btech_ece_online_r1_offer_cancelled: number;

  btech_aids_online_r1_accepted: number;
  btech_aids_online_r1_rejected: number;
  btech_aids_online_r1_withdrawn: number;
  btech_aids_online_r1_offer_cancelled: number;

  imtech_cse_online_r1_accepted: number;
  imtech_cse_online_r1_rejected: number;
  imtech_cse_online_r1_withdrawn: number;
  imtech_cse_online_r1_offer_cancelled: number;

  imtech_ece_online_r1_accepted: number;
  imtech_ece_online_r1_rejected: number;
  imtech_ece_online_r1_withdrawn: number;
  imtech_ece_online_r1_offer_cancelled: number;

  btech_cse_online_r2_accepted: number;
  btech_aids_online_r2_accepted: number;
  btech_ece_online_r2_accepted: number;
  imtech_cse_online_r2_accepted: number;
  imtech_ece_online_r2_accepted: number;

  btech_cse_online_r2_slide_accepted: number;
  btech_aids_online_r2_slide_accepted: number;
  btech_ece_online_r2_slide_accepted: number;
  imtech_cse_online_r2_slide_accepted: number;
  imtech_ece_online_r2_slide_accepted: number;

  btech_cse_online_r3_accepted: number;
  btech_aids_online_r3_accepted: number;
  btech_ece_online_r3_accepted: number;
  imtech_cse_online_r3_accepted: number;
  imtech_ece_online_r3_accepted: number;

  btech_cse_online_r3_slide_accepted: number;
  btech_aids_online_r3_slide_accepted: number;
  btech_ece_online_r3_slide_accepted: number;
  imtech_cse_online_r3_slide_accepted: number;
  imtech_ece_online_r3_slide_accepted: number;

  mtech_cse_online_r1_accepted: number;
  mtech_cse_online_r1_rejected: number;
  mtech_cse_online_r1_withdrawn: number;
  mtech_cse_online_r1_offer_cancelled: number;

  mtech_ece_online_r1_accepted: number;
  mtech_ece_online_r1_rejected: number;
  mtech_ece_online_r1_withdrawn: number;
  mtech_ece_online_r1_offer_cancelled: number;

  mtech_aids_online_r1_accepted: number;
  mtech_aids_online_r1_rejected: number;
  mtech_aids_online_r1_withdrawn: number;
  mtech_aids_online_r1_offer_cancelled: number;

  mtech_cse_online_r2_accepted: number;
  mtech_cse_online_r2_rejected: number;
  mtech_cse_online_r2_withdrawn: number;
  mtech_cse_online_r2_offer_cancelled: number;

  mtech_ece_online_r2_accepted: number;
  mtech_ece_online_r2_rejected: number;
  mtech_ece_online_r2_withdrawn: number;
  mtech_ece_online_r2_offer_cancelled: number;

  mtech_aids_online_r2_accepted: number;
  mtech_aids_online_r2_rejected: number;
  mtech_aids_online_r2_withdrawn: number;
  mtech_aids_online_r2_offer_cancelled: number;

  btech_cse_accepted_or1: number;
  btech_aids_accepted_or1: number;
  btech_ece_accepted_or1: number;
  imtech_cse_accepted_or1: number;
  imtech_ece_accepted_or1: number;

  imtech_ece_online_r1_slide_accepted: number;
  imtech_cse_online_r1_slide_accepted: number;
  btech_ece_online_r1_slide_accepted: number;
  btech_aids_online_r1_slide_accepted: number;
  btech_cse_online_r1_slide_accepted: number;
  imtech_ece_slide_accepted_r3: number;
  imtech_ece_slide_accepted_r2: number;
  imtech_ece_slide_accepted_r1: number;
  imtech_cse_slide_accepted_r3: number;
  imtech_cse_slide_accepted_r2: number;
  imtech_cse_slide_accepted_r1: number;
  btech_ece_slide_accepted_r3: number;
  btech_ece_slide_accepted_r2: number;
  btech_ece_slide_accepted_r1: number;
  btech_aids_slide_accepted_r3: number;
  btech_aids_slide_accepted_r2: number;
  btech_aids_slide_accepted_r1: number;
  btech_cse_slide_accepted_r3: number;
  btech_cse_slide_accepted_r2: number;
  btech_cse_slide_accepted_r1: number;

}

export default function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const [showDropdown, setShowDropdown] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showHelpPopup, setShowHelpPopup] = useState(false);
  const [showMyQueriesPopup, setShowMyQueriesPopup] = useState(false);
  const [showQueryChatPopup, setShowQueryChatPopup] = useState(false);
  const [showAllQueriesPopup, setShowAllQueriesPopup] = useState(false);
  const [selectedQueryId, setSelectedQueryId] = useState<string>("");
  const [selectedQuerySubject, setSelectedQuerySubject] = useState<string>("");
  const [selectedQuery, setSelectedQuery] = useState<help_desk_query | null>(null);
  const [queryUpdateKey, setQueryUpdateKey] = useState(0);

  const [analytics, setAnalytics] = useState<AnalyticsCounts | null>(null);
  const [analyticsLoading, setAnalyticsLoading] = useState(true);

  const [btechVacancies, setBtechVacancies] = useState<any>(null);
  const [vacanciesLoading, setVacanciesLoading] = useState(false);
  const [applications, setApplications] = useState<Application[]>([]);

  const { user } = useContext(LoginContext);
  const isAdmin = user?.role === "admin";

  // Open AllQueriesPopup if navigated here via sidebar "Queries" item
  useEffect(() => {
    if ((location.state as any)?.openQueries && isAdmin) {
      if (location.state?.showAllQueriesPopup) {
        setShowAllQueriesPopup(location.state?.showAllQueriesPopup);
      }
      navigate("/allQueries", { state: { isOpen: true } })
      // Clear state so refreshing doesn't re-open
      window.history.replaceState({}, document.title);
    }
  }, [location.state, isAdmin]);

  // Fetch analytics counts for admin
  useEffect(() => {
    if (!isAdmin) return;
    const fetchAnalytics = async () => {
      setAnalyticsLoading(true);
      try {
        const url = `${apiConfig.getResourceUrl("applications")}?queryId=GET_ANALYTICS_COUNTS`;
        const res = await apiFetch(url, { method: "GET" });
        if (res.ok) {
          const data = await res.json();
          const resources = data.resource || [];
          if (resources.length > 0 && resources[0].extra_data) {
            setAnalytics(resources[0].extra_data as AnalyticsCounts);
          }
        }
      } catch (err) {
        console.error("Error fetching analytics:", err);
      } finally {
        setAnalyticsLoading(false);
      }
    };
    fetchAnalytics();
  }, [isAdmin]);

  const fetchVacancies = async () => {
    setVacanciesLoading(true);
    try {
      const url = `${apiConfig.getResourceUrl("applications")}?queryId=GET_BTECH_VACANCIES`;
      const res = await apiFetch(url, { method: "GET" });
      if (res.ok) {
        const data = await res.json();
        if (data.resource && data.resource.length > 0) {
          setBtechVacancies(data.resource[0].extra_data);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setVacanciesLoading(false);
    }
  };

  // Back handler for QueryChatPopup — admin goes back to AllQueries, student goes back to MyQueries
  const handleChatBack = () => {
    setShowQueryChatPopup(false);
    setSelectedQueryId("");
    setSelectedQuerySubject("");
    setSelectedQuery(null);
    if (isAdmin) {
      setShowAllQueriesPopup(true);
    } else {
      setShowMyQueriesPopup(true);
    }
  };

  const n = (val: number | undefined) => (val ?? 0);

  return (
    <div className="dash-layout">
      <SidebarAdmin
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={() => setSidebarCollapsed((p) => !p)}
      />

      <div
        className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""}`}
      >
        <header className="dash-header">
          <h1 className="dash-page-title">Dashboard</h1>
          <div className="dash-profile-sec">
            {/* Help icon only for Students */}
            {!isAdmin && (
              <img
                src={HelpIcon}
                className="help_icon"
                alt="help-icon"
                onClick={() => setShowHelpPopup(true)}
              />
            )}

            <div className="dash-user-profile">
              <div
                className="dash-profile-circle"
                onClick={() => setShowDropdown((p) => !p)}
              >
                <span>A</span>
              </div>
            </div>

            {showDropdown && (
              <div className="dash-profile-dropdown">
                <LogoutButton />
              </div>
            )}
          </div>
        </header>

        <div className="dash-content-body">
          {isAdmin && (
            <div className="analytics-section" >
              <h2 className="analytics-title" style={{ marginBottom: "15px" }}>M.Tech Applications</h2>

              {analyticsLoading ? (
                <div className="analytics-loading">Loading analytics...</div>
              ) : analytics ? (
                <>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <h6 style={{ fontSize: 13 }}>O- Offered, A- Accepted, D- Declined, C- Cancelled, S-Selected, R-Registered</h6>
                  </div>
                  <div className="analytics-table-wrapper" style={{ marginBottom: "40px", overflow: "scroll" }}>
                    <table className="analytics-table">
                      <thead>
                        <tr>
                          <th>Programme (Seats)</th>
                          <th>Accepted / Withdrawn / Paid / Total</th>
                          <th>Online Round - 2 (A)</th>
                          <th>Online Round - 1 (A)</th>
                          <th>Round - 3 O (A / D / C)</th>
                          <th>Round - 2 O (A / D / C)</th>
                          <th>Round - 1 O (A / D / C)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {/* TOTAL */}
                        <tr className="analytics-row-total">
                          <td><strong>Total (180)</strong></td>

                          <td>
                            <strong>
                              {n(
                                analytics.mtech_cse_accepted_r3 +
                                analytics.mtech_ece_accepted_r3 +
                                analytics.mtech_aids_accepted_r3 +
                                analytics.mtech_cse_accepted_r2 +
                                analytics.mtech_ece_accepted_r2 +
                                analytics.mtech_aids_accepted_r2 +
                                analytics.mtech_cse_accepted_r1 +
                                analytics.mtech_ece_accepted_r1 +
                                analytics.mtech_aids_accepted_r1 +
                                analytics.mtech_cse_online_r1_accepted +
                                analytics.mtech_ece_online_r1_accepted +
                                analytics.mtech_aids_online_r1_accepted +
                                analytics.mtech_cse_online_r2_accepted +
                                analytics.mtech_ece_online_r2_accepted +
                                analytics.mtech_aids_online_r2_accepted
                              )}
                              / {n(
                                analytics.mtech_cse_with +
                                analytics.mtech_ece_with +
                                analytics.mtech_aids_with
                              )}
                              / {n(analytics.submitted_paid)}
                              / {n(analytics.total)}
                            </strong>
                          </td>
                          <td>{n(analytics.mtech_cse_online_r2_accepted) + n(analytics.mtech_ece_online_r2_accepted) + n(analytics.mtech_aids_online_r2_accepted)}</td>
                          <td>{n(analytics.mtech_cse_online_r1_accepted) + n(analytics.mtech_ece_online_r1_accepted) + n(analytics.mtech_aids_online_r1_accepted)}</td>

                          <td>
                            <strong>
                              {n(
                                analytics.mtech_cse_offered_r3 +
                                analytics.mtech_ece_offered_r3 +
                                analytics.mtech_aids_offered_r3
                              )}
                              (
                              {n(
                                analytics.mtech_cse_accepted_r3 +
                                analytics.mtech_ece_accepted_r3 +
                                analytics.mtech_aids_accepted_r3
                              )}
                              /
                              {n(
                                analytics.mtech_cse_declined_r3 +
                                analytics.mtech_ece_declined_r3 +
                                analytics.mtech_aids_declined_r3
                              )}
                              /
                              {n(
                                analytics.mtech_cse_cancelled_r3 +
                                analytics.mtech_ece_cancelled_r3 +
                                analytics.mtech_aids_cancelled_r3
                              )}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(
                                analytics.mtech_cse_offered_r2 +
                                analytics.mtech_ece_offered_r2 +
                                analytics.mtech_aids_offered_r2
                              )}
                              (
                              {n(
                                analytics.mtech_cse_accepted_r2 +
                                analytics.mtech_ece_accepted_r2 +
                                analytics.mtech_aids_accepted_r2
                              )}
                              /
                              {n(
                                analytics.mtech_cse_declined_r2 +
                                analytics.mtech_ece_declined_r2 +
                                analytics.mtech_aids_declined_r2
                              )}
                              /
                              {n(
                                analytics.mtech_cse_cancelled_r2 +
                                analytics.mtech_ece_cancelled_r2 +
                                analytics.mtech_aids_cancelled_r2
                              )}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              <strong>
                                {n(
                                  analytics.mtech_cse_offered_r1 +
                                  analytics.mtech_ece_offered_r1 +
                                  analytics.mtech_aids_offered_r1
                                )}
                                (
                                {n(
                                  analytics.mtech_cse_accepted_r1 +
                                  analytics.mtech_ece_accepted_r1 +
                                  analytics.mtech_aids_accepted_r1
                                )}
                                /
                                {n(
                                  analytics.mtech_cse_declined_r1 +
                                  analytics.mtech_ece_declined_r1 +
                                  analytics.mtech_aids_declined_r1
                                )}
                                /
                                {n(
                                  analytics.mtech_cse_cancelled_r1 +
                                  analytics.mtech_ece_cancelled_r1 +
                                  analytics.mtech_aids_cancelled_r1
                                )}
                                )
                              </strong>
                            </strong>
                          </td>
                        </tr>

                        {/* CSE */}
                        <tr>
                          <td>M.Tech CSE (120)</td>

                          <td>
                            {n(
                              analytics.mtech_cse_accepted_r3 +
                              analytics.mtech_cse_accepted_r2 +
                              analytics.mtech_cse_accepted_r1 +
                              analytics.mtech_cse_online_r1_accepted +
                              analytics.mtech_cse_online_r2_accepted
                            )}
                            / {n(analytics.mtech_cse_with)}
                            / {n(analytics.cse_submitted_paid)} / {n(analytics.cse_total)}
                          </td>
                          <td>{n(analytics.mtech_cse_online_r2_accepted)}</td>
                          <td>{n(analytics.mtech_cse_online_r1_accepted)}</td>

                          <td>
                            {n(analytics.mtech_cse_offered_r3)}
                            (
                            {n(analytics.mtech_cse_accepted_r3)} /
                            {n(analytics.mtech_cse_declined_r3)} /
                            {n(analytics.mtech_cse_cancelled_r3)}
                            )
                          </td>

                          <td>
                            {n(analytics.mtech_cse_offered_r2)}
                            (
                            {n(analytics.mtech_cse_accepted_r2)} /
                            {n(analytics.mtech_cse_declined_r2)} /
                            {n(analytics.mtech_cse_cancelled_r2)}
                            )
                          </td>

                          <td>
                            {n(analytics.mtech_cse_offered_r1)}
                            (
                            {n(analytics.mtech_cse_accepted_r1)} /
                            {n(analytics.mtech_cse_declined_r1)} /
                            {n(analytics.mtech_cse_cancelled_r1)}
                            )
                          </td>
                        </tr>

                        {/* ECE */}
                        <tr>
                          <td>M.Tech ECE (30)</td>

                          <td>
                            {n(
                              analytics.mtech_ece_accepted_r3 +
                              analytics.mtech_ece_accepted_r2 +
                              analytics.mtech_ece_accepted_r1 +
                              analytics.mtech_ece_online_r1_accepted +
                              analytics.mtech_ece_online_r2_accepted
                            )}
                            / {n(analytics.mtech_ece_with)}
                            / {n(analytics.ece_submitted_paid)} / {n(analytics.ece_total)}
                          </td>
                          <td>{n(analytics.mtech_ece_online_r2_accepted)}</td>
                          <td>{n(analytics.mtech_ece_online_r1_accepted)}</td>

                          <td>
                            {n(analytics.mtech_ece_offered_r3)}
                            (
                            {n(analytics.mtech_ece_accepted_r3)} /
                            {n(analytics.mtech_ece_declined_r3)} /
                            {n(analytics.mtech_ece_cancelled_r3)}
                            )
                          </td>

                          <td>
                            {n(analytics.mtech_ece_offered_r2)}
                            (
                            {n(analytics.mtech_ece_accepted_r2)} /
                            {n(analytics.mtech_ece_declined_r2)} /
                            {n(analytics.mtech_ece_cancelled_r2)}
                            )
                          </td>

                          <td>
                            {n(analytics.mtech_ece_offered_r1)}
                            (
                            {n(analytics.mtech_ece_accepted_r1)} /
                            {n(analytics.mtech_ece_declined_r1)} /
                            {n(analytics.mtech_ece_cancelled_r1)}
                            )
                          </td>
                        </tr>

                        {/* AI/DS */}
                        <tr>
                          <td>M.Tech AI&amp;DS (30)</td>

                          <td>
                            {n(
                              analytics.mtech_aids_accepted_r3 +
                              analytics.mtech_aids_accepted_r2 +
                              analytics.mtech_aids_accepted_r1 +
                              analytics.mtech_aids_online_r1_accepted +
                              analytics.mtech_aids_online_r2_accepted
                            )}
                            / {n(analytics.mtech_aids_with)}
                            / {n(analytics.ai_ds_submitted_paid)} / {n(analytics.ai_ds_total)}
                          </td>
                          <td>{n(analytics.mtech_aids_online_r2_accepted)}</td>
                          <td>{n(analytics.mtech_aids_online_r1_accepted)}</td>

                          <td>
                            {n(analytics.mtech_aids_offered_r3)}
                            (
                            {n(analytics.mtech_aids_accepted_r3)} /
                            {n(analytics.mtech_aids_declined_r3)} /
                            {n(analytics.mtech_aids_cancelled_r3)}
                            )
                          </td>

                          <td>
                            {n(analytics.mtech_aids_offered_r2)}
                            (
                            {n(analytics.mtech_aids_accepted_r2)} /
                            {n(analytics.mtech_aids_declined_r2)} /
                            {n(analytics.mtech_aids_cancelled_r2)}
                            )
                          </td>

                          <td>
                            {n(analytics.mtech_aids_offered_r1)}
                            (
                            {n(analytics.mtech_aids_accepted_r1)} /
                            {n(analytics.mtech_aids_declined_r1)} /
                            {n(analytics.mtech_aids_cancelled_r1)}
                            )
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <h2 className="analytics-title" style={{ marginBottom: "15px" }}>B.Tech & Integrated M.Tech Applications</h2>
                  <div style={{ display: "flex", justifyContent: "flex-end", flexDirection: "column", alignItems: "flex-end", marginBottom: "10px" }}>
                    <h6 style={{ fontSize: 13, margin: 0 }}>O- Offered, A- Accepted, D- Declined, S-Selected, FA - Fresh Accepted, SA - Slide Accepted</h6>
                    <h6 style={{ fontSize: 11, color: "#666", margin: "5px 0 0 0", fontWeight: "normal", textAlign: "right" }}>
                      * Note: <strong>"Accepted"</strong> counts each candidate only once.
                      If someone moved through multiple rounds (e.g., R1 → R2 → R3),<br /> they're counted only in the final round where they ended up.
                    </h6>
                  </div>
                  <div className="analytics-table-wrapper" style={{ overflow: "scroll" }}>
                    <table className="analytics-table">
                      <thead>
                        <tr>
                          <th>Programme (Seats)</th>
                          <th>Accepted / Withdrawn / Paid / Total</th>
                          <th>Online Round - 3 (FA / SA)</th>
                          <th>Online Round - 2 (FA / SA)</th>
                          <th>Online Round - 1 (FA / SA)</th>
                          <th>Round - 3 O (FA / SA / D)</th>
                          <th>Round - 2 O (FA / SA / D)</th>
                          <th>Round - 1 O (A / D)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {/* TOTAL */}
                        <tr className="analytics-row-total">
                          <td><strong>Total (360)</strong></td>

                          <td>
                            <strong>
                              {n(
                                analytics.btech_cse_accepted_r3 +
                                analytics.btech_cse_slide_accepted_r3 +
                                analytics.btech_ece_accepted_r3 +
                                analytics.btech_ece_slide_accepted_r3 +
                                analytics.btech_aids_accepted_r3 +
                                analytics.btech_aids_slide_accepted_r3 +
                                analytics.imtech_cse_accepted_r3 +
                                analytics.imtech_cse_slide_accepted_r3 +
                                analytics.imtech_ece_accepted_r3 +
                                analytics.imtech_ece_slide_accepted_r3 +

                                analytics.btech_cse_accepted_r2 +
                                analytics.btech_cse_slide_accepted_r2 +
                                analytics.btech_ece_accepted_r2 +
                                analytics.btech_ece_slide_accepted_r2 +
                                analytics.btech_aids_accepted_r2 +
                                analytics.btech_aids_slide_accepted_r2 +
                                analytics.imtech_cse_accepted_r2 +
                                analytics.imtech_cse_slide_accepted_r2 +
                                analytics.imtech_ece_accepted_r2 +
                                analytics.imtech_ece_slide_accepted_r2 +

                                analytics.btech_cse_accepted_r1 +
                                analytics.btech_cse_slide_accepted_r1 +
                                analytics.btech_ece_accepted_r1 +
                                analytics.btech_ece_slide_accepted_r1 +
                                analytics.btech_aids_accepted_r1 +
                                analytics.btech_aids_slide_accepted_r1 +
                                analytics.imtech_cse_accepted_r1 +
                                analytics.imtech_cse_slide_accepted_r1 +
                                analytics.imtech_ece_accepted_r1 +
                                analytics.imtech_ece_slide_accepted_r1 +

                                analytics.btech_cse_online_r2_accepted +
                                analytics.btech_cse_online_r2_slide_accepted +
                                analytics.btech_ece_online_r2_accepted +
                                analytics.btech_ece_online_r2_slide_accepted +
                                analytics.btech_aids_online_r2_accepted +
                                analytics.btech_aids_online_r2_slide_accepted +
                                analytics.imtech_cse_online_r2_accepted +
                                analytics.imtech_cse_online_r2_slide_accepted +
                                analytics.imtech_ece_online_r2_accepted +
                                analytics.imtech_ece_online_r2_slide_accepted +

                                analytics.btech_cse_online_r3_accepted +
                                analytics.btech_cse_online_r3_slide_accepted +
                                analytics.btech_ece_online_r3_accepted +
                                analytics.btech_ece_online_r3_slide_accepted +
                                analytics.btech_aids_online_r3_accepted +
                                analytics.btech_aids_online_r3_slide_accepted +
                                analytics.imtech_cse_online_r3_accepted +
                                analytics.imtech_cse_online_r3_slide_accepted +
                                analytics.imtech_ece_online_r3_accepted +
                                analytics.imtech_ece_online_r3_slide_accepted +

                                analytics.btech_cse_online_r1_accepted +
                                analytics.btech_cse_online_r1_slide_accepted +
                                analytics.btech_ece_online_r1_accepted +
                                analytics.btech_ece_online_r1_slide_accepted +
                                analytics.btech_aids_online_r1_accepted +
                                analytics.btech_aids_online_r1_slide_accepted +
                                analytics.imtech_cse_online_r1_accepted +
                                analytics.imtech_cse_online_r1_slide_accepted +
                                analytics.imtech_ece_online_r1_accepted +
                                analytics.imtech_ece_online_r1_slide_accepted
                              )}
                              /
                              {n(
                                analytics.btech_cse_with +
                                analytics.btech_ece_with +
                                analytics.btech_aids_with +
                                analytics.imtech_cse_with +
                                analytics.imtech_ece_with
                              )}
                              / {n(analytics.btech_submitted_paid)} / {n(analytics.btech_total)}
                            </strong>
                          </td>

                          <td>{
                            n(analytics.btech_cse_online_r3_accepted) +
                            n(analytics.btech_ece_online_r3_accepted) +
                            n(analytics.btech_aids_online_r3_accepted) +
                            n(analytics.imtech_cse_online_r3_accepted) +
                            n(analytics.imtech_ece_online_r3_accepted)
                          } / {
                              n(analytics.btech_cse_online_r3_slide_accepted) +
                              n(analytics.btech_ece_online_r3_slide_accepted) +
                              n(analytics.btech_aids_online_r3_slide_accepted) +
                              n(analytics.imtech_cse_online_r3_slide_accepted) +
                              n(analytics.imtech_ece_online_r3_slide_accepted)
                            }</td>
                          <td>{
                            n(analytics.btech_cse_online_r2_accepted) +
                            n(analytics.btech_ece_online_r2_accepted) +
                            n(analytics.btech_aids_online_r2_accepted) +
                            n(analytics.imtech_cse_online_r2_accepted) +
                            n(analytics.imtech_ece_online_r2_accepted)
                          } / {
                              n(analytics.btech_cse_online_r2_slide_accepted) +
                              n(analytics.btech_ece_online_r2_slide_accepted) +
                              n(analytics.btech_aids_online_r2_slide_accepted) +
                              n(analytics.imtech_cse_online_r2_slide_accepted) +
                              n(analytics.imtech_ece_online_r2_slide_accepted)
                            }</td>
                          <td>{
                            n(analytics.btech_cse_online_r1_accepted) +
                            n(analytics.btech_ece_online_r1_accepted) +
                            n(analytics.btech_aids_online_r1_accepted) +
                            n(analytics.imtech_cse_online_r1_accepted) +
                            n(analytics.imtech_ece_online_r1_accepted)
                          } / {
                              n(analytics.btech_cse_online_r1_slide_accepted) +
                              n(analytics.btech_ece_online_r1_slide_accepted) +
                              n(analytics.btech_aids_online_r1_slide_accepted) +
                              n(analytics.imtech_cse_online_r1_slide_accepted) +
                              n(analytics.imtech_ece_online_r1_slide_accepted)
                            }</td>
                          <td>
                            <strong>
                              {n(
                                analytics.btech_cse_offered_r3 +
                                analytics.btech_ece_offered_r3 +
                                analytics.btech_aids_offered_r3 +
                                analytics.imtech_cse_offered_r3 +
                                analytics.imtech_ece_offered_r3
                              )}
                              (
                              {n(
                                analytics.btech_cse_accepted_r3 +
                                analytics.btech_ece_accepted_r3 +
                                analytics.btech_aids_accepted_r3 +
                                analytics.imtech_cse_accepted_r3 +
                                analytics.imtech_ece_accepted_r3
                              )} / {
                                n(analytics.btech_cse_slide_accepted_r3) +
                                n(analytics.btech_ece_slide_accepted_r3) +
                                n(analytics.btech_aids_slide_accepted_r3) +
                                n(analytics.imtech_cse_slide_accepted_r3) +
                                n(analytics.imtech_ece_slide_accepted_r3)
                              } /  {n(
                                analytics.btech_cse_declined_r3 +
                                analytics.btech_ece_declined_r3 +
                                analytics.btech_aids_declined_r3 +
                                analytics.imtech_cse_declined_r3 +
                                analytics.imtech_ece_declined_r3
                              )}
                              {/* /
                              {n(
                                analytics.btech_cse_cancelled_r3 +
                                analytics.btech_ece_cancelled_r3 +
                                analytics.btech_aids_cancelled_r3 +
                                analytics.imtech_cse_cancelled_r3 +
                                analytics.imtech_ece_cancelled_r3
                              )} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(
                                analytics.btech_cse_offered_r2 +
                                analytics.btech_ece_offered_r2 +
                                analytics.btech_aids_offered_r2 +
                                analytics.imtech_cse_offered_r2 +
                                analytics.imtech_ece_offered_r2
                              )}
                              (
                              {n(
                                analytics.btech_cse_accepted_r2 +
                                analytics.btech_ece_accepted_r2 +
                                analytics.btech_aids_accepted_r2 +
                                analytics.imtech_cse_accepted_r2 +
                                analytics.imtech_ece_accepted_r2
                              )} / {
                                n(analytics.btech_cse_slide_accepted_r2) +
                                n(analytics.btech_ece_slide_accepted_r2) +
                                n(analytics.btech_aids_slide_accepted_r2) +
                                n(analytics.imtech_cse_slide_accepted_r2) +
                                n(analytics.imtech_ece_slide_accepted_r2)
                              } / {n(
                                analytics.btech_cse_declined_r2 +
                                analytics.btech_ece_declined_r2 +
                                analytics.btech_aids_declined_r2 +
                                analytics.imtech_cse_declined_r2 +
                                analytics.imtech_ece_declined_r2
                              )}
                              {/* /
                              {n(
                                analytics.btech_cse_cancelled_r2 +
                                analytics.btech_ece_cancelled_r2 +
                                analytics.btech_aids_cancelled_r2 +
                                analytics.imtech_cse_cancelled_r2 +
                                analytics.imtech_ece_cancelled_r2
                              )} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(
                                analytics.btech_cse_offered_r1 +
                                analytics.btech_ece_offered_r1 +
                                analytics.btech_aids_offered_r1 +
                                analytics.imtech_cse_offered_r1 +
                                analytics.imtech_ece_offered_r1
                              )}
                              (
                              {n(
                                analytics.btech_cse_accepted_r1 +
                                analytics.btech_ece_accepted_r1 +
                                analytics.btech_aids_accepted_r1 +
                                analytics.imtech_cse_accepted_r1 +
                                analytics.imtech_ece_accepted_r1
                              )} / {n(
                                analytics.btech_cse_declined_r1 +
                                analytics.btech_ece_declined_r1 +
                                analytics.btech_aids_declined_r1 +
                                analytics.imtech_cse_declined_r1 +
                                analytics.imtech_ece_declined_r1
                              )}
                              {/* /
                              {n(
                                analytics.btech_cse_cancelled_r1 +
                                analytics.btech_ece_cancelled_r1 +
                                analytics.btech_aids_cancelled_r1 +
                                analytics.imtech_cse_cancelled_r1 +
                                analytics.imtech_ece_cancelled_r1
                              )} */}
                              )
                            </strong>
                          </td>
                        </tr>

                        {/* CSE */}
                        <tr>
                          <td>B.Tech CSE (120)</td>

                          <td>
                            {n(
                              analytics.btech_cse_accepted_r3 +
                              analytics.btech_cse_accepted_r2 +
                              analytics.btech_cse_accepted_r1 +
                              analytics.btech_cse_online_r3_accepted +
                              analytics.btech_cse_online_r2_accepted +
                              analytics.btech_cse_online_r1_accepted +
                              analytics.btech_cse_slide_accepted_r3 +
                              analytics.btech_cse_slide_accepted_r2 +
                              analytics.btech_cse_slide_accepted_r1 +
                              analytics.btech_cse_online_r3_slide_accepted +
                              analytics.btech_cse_online_r2_slide_accepted +
                              analytics.btech_cse_online_r1_slide_accepted
                            )}
                            / {n(analytics.btech_cse_with)}
                            / {n(analytics.btech_cse_submitted_paid)} / {n(analytics.btech_cse_total)}
                          </td>
                          <td>{n(analytics.btech_cse_online_r3_accepted)} / {n(analytics.btech_cse_online_r3_slide_accepted)}</td>
                          <td>{n(analytics.btech_cse_online_r2_accepted)} / {n(analytics.btech_cse_online_r2_slide_accepted)}</td>
                          <td>{n(analytics.btech_cse_online_r1_accepted)} / {n(analytics.btech_cse_online_r1_slide_accepted)}</td>

                          <td>
                            <strong>
                              {n(analytics.btech_cse_offered_r3)}
                              (
                              {n(analytics.btech_cse_accepted_r3)} / {n(analytics.btech_cse_slide_accepted_r3)} / {n(analytics.btech_cse_declined_r3)}
                              {/* /{n(analytics.btech_cse_cancelled_r3)} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(analytics.btech_cse_offered_r2)}
                              (
                              {n(analytics.btech_cse_accepted_r2)} / {n(analytics.btech_cse_slide_accepted_r2)} / {n(analytics.btech_cse_declined_r2)}
                              {/* /{n(analytics.btech_cse_cancelled_r2)} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(analytics.btech_cse_offered_r1)} ( {n(analytics.btech_cse_accepted_r1)} / {n(analytics.btech_cse_declined_r1)}
                              {/* /{n(analytics.btech_cse_cancelled_r1)} */}
                              )
                            </strong>
                          </td>
                        </tr>

                        {/* ECE */}
                        <tr>
                          <td>B.Tech ECE (120)</td>
                          <td>
                            {n(
                              analytics.btech_ece_accepted_r3 +
                              analytics.btech_ece_accepted_r2 +
                              analytics.btech_ece_accepted_r1 +
                              analytics.btech_ece_online_r3_accepted +
                              analytics.btech_ece_online_r2_accepted +
                              analytics.btech_ece_online_r1_accepted +
                              analytics.btech_ece_slide_accepted_r3 +
                              analytics.btech_ece_slide_accepted_r2 +
                              analytics.btech_ece_slide_accepted_r1 +
                              analytics.btech_ece_online_r3_slide_accepted +
                              analytics.btech_ece_online_r2_slide_accepted +
                              analytics.btech_ece_online_r1_slide_accepted
                            )}
                            / {n(analytics.btech_ece_with)}
                            / {n(analytics.btech_ece_submitted_paid)}
                            / {n(analytics.btech_ece_total)}
                          </td>
                          <td>
                            {n(analytics.btech_ece_online_r3_accepted)} / {n(analytics.btech_ece_online_r3_slide_accepted)}
                          </td>
                          <td>
                            {n(analytics.btech_ece_online_r2_accepted)} / {n(analytics.btech_ece_online_r2_slide_accepted)}
                          </td>
                          <td>
                            {n(analytics.btech_ece_online_r1_accepted)} / {n(analytics.btech_ece_online_r1_slide_accepted)}
                          </td>
                          <td>
                            <strong>
                              {n(analytics.btech_ece_offered_r3)}
                              (
                              {n(analytics.btech_ece_accepted_r3)} / {n(analytics.btech_ece_slide_accepted_r3)} / {n(analytics.btech_ece_declined_r3)}
                              {/* /{n(analytics.btech_ece_cancelled_r3)} */}
                              )
                            </strong>
                          </td>
                          <td>
                            <strong>
                              {n(analytics.btech_ece_offered_r2)}
                              (
                              {n(analytics.btech_ece_accepted_r2)} / {n(analytics.btech_ece_slide_accepted_r2)} / {n(analytics.btech_ece_declined_r2)}
                              {/* /{n(analytics.btech_ece_cancelled_r2)} */}
                              )
                            </strong>
                          </td>
                          <td>
                            <strong>
                              {n(analytics.btech_ece_offered_r1)}
                              (
                              {n(analytics.btech_ece_accepted_r1)} / {n(analytics.btech_ece_declined_r1)}
                              {/* /{n(analytics.btech_ece_cancelled_r1)} */}
                              )
                            </strong>
                          </td>
                        </tr>

                        {/* AI/DS */}
                        <tr>
                          <td>B.Tech AI&amp;DS (90)</td>

                          <td>
                            {n(
                              analytics.btech_aids_accepted_r3 +
                              analytics.btech_aids_accepted_r2 +
                              analytics.btech_aids_accepted_r1 +
                              analytics.btech_aids_online_r3_accepted +
                              analytics.btech_aids_online_r2_accepted +
                              analytics.btech_aids_online_r1_accepted +
                              analytics.btech_aids_slide_accepted_r3 +
                              analytics.btech_aids_slide_accepted_r2 +
                              analytics.btech_aids_slide_accepted_r1 +
                              analytics.btech_aids_online_r3_slide_accepted +
                              analytics.btech_aids_online_r2_slide_accepted +
                              analytics.btech_aids_online_r1_slide_accepted
                            )}
                            / {n(analytics.btech_aids_with)}
                            / {n(analytics.btech_ai_ds_submitted_paid)} / {n(analytics.btech_ai_ds_total)}
                          </td>
                          <td>
                            {n(analytics.btech_aids_online_r3_accepted)} / {n(analytics.btech_aids_online_r3_slide_accepted)}
                          </td>
                          <td>
                            {n(analytics.btech_aids_online_r2_accepted)} / {n(analytics.btech_aids_online_r2_slide_accepted)}
                          </td>
                          <td>
                            {n(analytics.btech_aids_online_r1_accepted)} / {n(analytics.btech_aids_online_r1_slide_accepted)}
                          </td>
                          <td>
                            <strong>
                              {n(analytics.btech_aids_offered_r3)}
                              (
                              {n(analytics.btech_aids_accepted_r3)} / {n(analytics.btech_aids_slide_accepted_r3)} / {n(analytics.btech_aids_declined_r3)}
                              {/* /{n(analytics.btech_aids_cancelled_r3)} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(analytics.btech_aids_offered_r2)}
                              (
                              {n(analytics.btech_aids_accepted_r2)} / {n(analytics.btech_aids_slide_accepted_r2)} / {n(analytics.btech_aids_declined_r2)}
                              {/* /{n(analytics.btech_aids_cancelled_r2)} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(analytics.btech_aids_offered_r1)} (
                              {n(analytics.btech_aids_accepted_r1)} / {n(analytics.btech_aids_declined_r1)}
                              {/* /{n(analytics.btech_aids_cancelled_r1)} */}
                              )
                            </strong>
                          </td>
                        </tr>

                        {/* IMTECH CSE */}
                        <tr>
                          <td>Integrated M.Tech CSE (60)</td>

                          <td>
                            {n(
                              analytics.imtech_cse_accepted_r3 +
                              analytics.imtech_cse_accepted_r2 +
                              analytics.imtech_cse_accepted_r1 +
                              analytics.imtech_cse_online_r3_accepted +
                              analytics.imtech_cse_online_r2_accepted +
                              analytics.imtech_cse_online_r1_accepted +
                              analytics.imtech_cse_slide_accepted_r3 +
                              analytics.imtech_cse_slide_accepted_r2 +
                              analytics.imtech_cse_slide_accepted_r1 +
                              analytics.imtech_cse_online_r3_slide_accepted +
                              analytics.imtech_cse_online_r2_slide_accepted +
                              analytics.imtech_cse_online_r1_slide_accepted
                            )} / {n(analytics.imtech_cse_with)} / {n(analytics.imtech_cse_submitted_paid)} / {n(analytics.imtech_cse_total)}
                          </td>
                          <td>{n(analytics.imtech_cse_online_r3_accepted)} / {n(analytics.imtech_cse_online_r3_slide_accepted)}</td>
                          <td>{n(analytics.imtech_cse_online_r2_accepted)} / {n(analytics.imtech_cse_online_r2_slide_accepted)}</td>
                          <td>{n(analytics.imtech_cse_online_r1_accepted)} / {n(analytics.imtech_cse_online_r1_slide_accepted)}</td>

                          <td>
                            <strong>
                              {n(analytics.imtech_cse_offered_r3)}
                              (
                              {n(analytics.imtech_cse_accepted_r3)} / {n(analytics.imtech_cse_slide_accepted_r3)} / {n(analytics.imtech_cse_declined_r3)}
                              {/* /{n(analytics.imtech_cse_cancelled_r3)} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(analytics.imtech_cse_offered_r2)}
                              (
                              {n(analytics.imtech_cse_accepted_r2)} / {n(analytics.imtech_cse_slide_accepted_r2)} / {n(analytics.imtech_cse_declined_r2)}
                              {/* /{n(analytics.imtech_cse_cancelled_r2)} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(analytics.imtech_cse_offered_r1)} (
                              {n(analytics.imtech_cse_accepted_r1)} / {n(analytics.imtech_cse_declined_r1)}
                              {/* /{n(analytics.imtech_cse_cancelled_r1)} */}
                              )
                            </strong>
                          </td>
                        </tr>

                        {/* IMTECH ECE */}
                        <tr>
                          <td>Integrated M.Tech ECE (60)</td>

                          <td>
                            {n(
                              analytics.imtech_ece_accepted_r3 +
                              analytics.imtech_ece_accepted_r2 +
                              analytics.imtech_ece_accepted_r1 +
                              analytics.imtech_ece_online_r3_accepted +
                              analytics.imtech_ece_online_r2_accepted +
                              analytics.imtech_ece_online_r1_accepted +
                              analytics.imtech_ece_slide_accepted_r3 +
                              analytics.imtech_ece_slide_accepted_r2 +
                              analytics.imtech_ece_slide_accepted_r1 +
                              analytics.imtech_ece_online_r3_slide_accepted +
                              analytics.imtech_ece_online_r2_slide_accepted +
                              analytics.imtech_ece_online_r1_slide_accepted
                            )} / {n(analytics.imtech_ece_with)} / {n(analytics.imtech_ece_submitted_paid)} / {n(analytics.imtech_ece_total)}
                          </td>
                          <td>{n(analytics.imtech_ece_online_r3_accepted)} / {n(analytics.imtech_ece_online_r3_slide_accepted)}</td>
                          <td>{n(analytics.imtech_ece_online_r2_accepted)} / {n(analytics.imtech_ece_online_r2_slide_accepted)}</td>
                          <td>{n(analytics.imtech_ece_online_r1_accepted)} / {n(analytics.imtech_ece_online_r1_slide_accepted)}</td>

                          <td>
                            <strong>
                              {n(analytics.imtech_ece_offered_r3)}
                              (
                              {n(analytics.imtech_ece_accepted_r3)} / {n(analytics.imtech_ece_slide_accepted_r3)} / {n(analytics.imtech_ece_declined_r3)}
                              {/* /{n(analytics.imtech_ece_cancelled_r3)} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(analytics.imtech_ece_offered_r2)}
                              (
                              {n(analytics.imtech_ece_accepted_r2)} / {n(analytics.imtech_ece_slide_accepted_r2)} / {n(analytics.imtech_ece_declined_r2)}
                              {/* /{n(analytics.imtech_ece_cancelled_r2)} */}
                              )
                            </strong>
                          </td>

                          <td>
                            <strong>
                              {n(analytics.imtech_ece_offered_r1)}
                              (
                              {n(analytics.imtech_ece_accepted_r1)} / {n(analytics.imtech_ece_declined_r1)}
                              {/* /{n(analytics.imtech_ece_cancelled_r1)} */}
                              )
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Sliding Vacancies Section
                  <div style={{ marginTop: "20px", padding: "20px", backgroundColor: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                      <h3 style={{ fontSize: "1.1rem", margin: 0, color: "#1e293b" }}>Calculate Round 2 Sliding Vacancies</h3>
                      <button 
                        className="btn btn-primary btn-sm" 
                        onClick={fetchVacancies}
                        disabled={vacanciesLoading}
                        style={{ backgroundColor: "#3b82f6", border: "none" }}
                      >
                        {vacanciesLoading ? "Calculating..." : "Calculate Vacancies"}
                      </button>
                    </div>
                    
                    {btechVacancies && (
                      <div className="analytics-table-wrapper">
                        <table className="analytics-table" style={{ background: "white" }}>
                          <thead>
                            <tr>
                              <th>Programme</th>
                              <th title="Total Fixed Institutional Capacity">Capacity</th>
                              <th title="Candidates with ACCEPTED verification and SUCCESS payment status">Locked Seats</th>
                              <th title="Suggested Vacancy count to enter for Sliding Round">Remaining Vacancy</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>B.Tech CSE</td>
                              <td>{n(btechVacancies.cap_btech_cse)}</td>
                              <td>{n(btechVacancies.locked_btech_cse)}</td>
                              <td className="fw-bold text-primary">{n(btechVacancies.vacancy_btech_cse)}</td>
                            </tr>
                            <tr>
                              <td>B.Tech ECE</td>
                              <td>{n(btechVacancies.cap_btech_ece)}</td>
                              <td>{n(btechVacancies.locked_btech_ece)}</td>
                              <td className="fw-bold text-primary">{n(btechVacancies.vacancy_btech_ece)}</td>
                            </tr>
                            <tr>
                              <td>B.Tech AI&amp;DS</td>
                              <td>{n(btechVacancies.cap_btech_aids)}</td>
                              <td>{n(btechVacancies.locked_btech_aids)}</td>
                              <td className="fw-bold text-primary">{n(btechVacancies.vacancy_btech_aids)}</td>
                            </tr>
                            <tr>
                              <td>Integrated M.Tech CSE</td>
                              <td>{n(btechVacancies.cap_imtech_cse)}</td>
                              <td>{n(btechVacancies.locked_imtech_cse)}</td>
                              <td className="fw-bold text-primary">{n(btechVacancies.vacancy_imtech_cse)}</td>
                            </tr>
                            <tr>
                              <td>Integrated M.Tech ECE</td>
                              <td>{n(btechVacancies.cap_imtech_ece)}</td>
                              <td>{n(btechVacancies.locked_imtech_ece)}</td>
                              <td className="fw-bold text-primary">{n(btechVacancies.vacancy_imtech_ece)}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginTop: "10px", fontSize: "0.85rem", color: "#64748b" }}>
                          <p className="mb-1"><strong>Note:</strong> A seat is considered locked if the candidate has an active offer, has paid the Seat Acceptance Fee (SUCCESS), and has completed JEE Verification (ACCEPTED).</p>
                        </div>
                      </div>
                    )}
                  </div>
                  */}
                </>
              ) : (
                <div className="analytics-loading">No data available.</div>
              )}
            </div>
          )}
        </div>

        {/* Student-only popups */}
        {!isAdmin && (
          <>
            {/* <HelpQueryPopup
              show={showHelpPopup}
              onClose={() => setShowHelpPopup(false)}
              openMyQueries={() => {
                setShowHelpPopup(false);
                setShowMyQueriesPopup(true);
              }}
            /> */}

            {/* <MyQueriesPopup
              isOpen={showMyQueriesPopup}
              onClose={() => setShowMyQueriesPopup(false)}
              openQueryChat={(query) => {
                if (query) {
                  setSelectedQueryId(query?.id);
                  setShowMyQueriesPopup(false);
                  setShowQueryChatPopup(true);
                  setSelectedQuery(query);
                } else {
                  // "Raise New Query" was clicked
                  setShowMyQueriesPopup(false);
                  setShowHelpPopup(true);
                }
              }}
            /> */}
          </>
        )}

        {/* Admin-only popup */}
        {isAdmin && (
          <AllQueriesPopup
            isOpen={showAllQueriesPopup}
            updateKey={queryUpdateKey}
            onClose={() => setShowAllQueriesPopup(false)}
            onViewQuery={(query: any) => {
              setSelectedQueryId(query.id);
              setSelectedQuerySubject(query.subject);
              setSelectedQuery(query);
              setShowAllQueriesPopup(false);
              setShowQueryChatPopup(true);
            }}
          />
        )}

        {/* QueryChat shared by both roles — back button routes to the correct parent */}
        {/* {selectedQuery &&
          <QueryChatPopup
            isOpen={showQueryChatPopup}
            onClose={() => {
              setShowQueryChatPopup(false);
              setSelectedQueryId("");
              setSelectedQuerySubject("");
              setSelectedQuery(null);
            }}
            onBack={handleChatBack}
            queryId={selectedQueryId}
            querySubject={selectedQuerySubject}
            query={selectedQuery}
            onStatusChange={() => setQueryUpdateKey((prev) => prev + 1)}
          />
        } */}
        {/* <Routes>
          <Route
            path="/query/:id"
            element={
              <ProtectedRoute>
                <QueryChatPopupWrapper
                  showQueryChatPopup={showQueryChatPopup}
                  setShowQueryChatPopup={setShowQueryChatPopup}
                  selectedQueryId={selectedQueryId}
                  selectedQuerySubject={selectedQuerySubject}
                  selectedQuery={selectedQuery}
                  handleChatBack={handleChatBack}
                  setSelectedQuery={setSelectedQuery}
                  setSelectedQueryId={setSelectedQueryId}
                  setSelectedQuerySubject={setSelectedQuerySubject}
                  setQueryUpdateKey={setQueryUpdateKey}
                />
              </ProtectedRoute>
            }
          />
        </Routes> */}
      </div>
    </div>
  );
}
